module.exports = __webpack_public_path__ + "static/img/nz.1bfe4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/nz.png
// module id = 0dyb
// module chunks = 18